import { BsCheckCircle } from 'react-icons/bs'
import MessagePage from '../../components/custom/Shared/MessagePage/MessagePage'

const SubscriptionCanceledSuccessfullyPage = () => {
  return (
    <MessagePage
      titleId="Subscription-Canceled-Successfully"
      messageIds={[
        'Your-subscription-has-been-canceled-successfully.',
        'You-will-no-longer-be-charged-for-this-service.',
        'If-you-have-any-questions-or-need-further-assistance,-please-contact-our-support-team.',
      ]}
      icon={BsCheckCircle}
      variant="green"
      redirectPath="mailto:Info@rosaas.app"
      redirectLabelId="Contact-Support"
    />
  )
}

export default SubscriptionCanceledSuccessfullyPage
